import {
    Autocomplete,
    Box,
    Breadcrumbs,
    Button,
    InputLabel,
    Paper,
    styled,
    TextField,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
    DataGridPro,
    GridColDef,
    GridPinnedColumnFields
} from "@mui/x-data-grid-pro";
import { ThreeDot } from "react-loading-indicators";
import emptyImage from "../assets/images/image.png";
import Grid from "@mui/material/Grid2";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import {
    addRbacUser,
    deleteRbacUser,
    getAddedUser,
    getRbacData,
    getRbacMetaDetails,
    updateRbacUser
} from "./ServiceRbac";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { showToast } from "../Components/Toast";
import { log } from "console";
import { getLoggedInName, getLoggedInUserID } from "../Utils/Constant";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

export const RbacData = () => {
    const loggedInName = getLoggedInName();

    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [allRows, setAllRows] = useState([]);

    const [selectedRow, setSelectedRow] = useState<any>(null);

    const [role, setRole] = React.useState("");
    const [department, setDepartment] = React.useState("");

    const [roles, setRoles] = useState<any[]>([]);
    const [departments, setDepartments] = useState<any[]>([]);

    // search state
    const [searchTerm, setSearchTerm] = useState("");
    const searchInputRef = useRef<HTMLInputElement>(null);

    // dialog state
    const [open, setOpen] = React.useState(false);
    const [openAdd, setOpenAdd] = React.useState(false);

    // Add user state
    const [newManagerName, setNewManagerName] = useState("");
    const [newManagerEmail, setNewManagerEmail] = useState("");
    const [newRole, setNewRole] = useState("");
    const [newDepartment, setNewDepartment] = useState("");

    const [managerOptions, setManagerOptions] = useState<any[]>([]);
    const [newManagerId, setNewManagerId] = useState("");

    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] =
        React.useState<DialogProps["maxWidth"]>("sm");
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
    const [rowToDelete, setRowToDelete] = React.useState(null);

    const handleDeleteUser = (row) => {
        setRowToDelete(row);
        setOpenDeleteDialog(true);
    };

    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });

    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            left: ["CORFQ_No", "CORFQ_Name"],
            right: ["Action"]
        });
    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );

    const fetchRbacData = async () => {
        setIsLoading(true);
        try {
            const response = await getRbacData("");
            const data = response?.data || [];
            const rowsWithId = data.map((item: any, index: number) => ({
                id: index,
                ...item
            }));
            console.log("aaaaaa", data);
            console.log("asdfdf", rowsWithId);
            setAllRows(rowsWithId);
            setRows(rowsWithId);
        } catch (err) {
            console.error("Failed to fetch proposals data", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchRbacData();
    }, []);

    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const search = event?.target?.value;
        setSearchTerm(search);

        if (search?.length >= 3) {
            const filtered = allRows?.filter((row) =>
                ["Manager_Name", "Manager_Email"].some(
                    (key) =>
                        typeof row[key] === "string" &&
                        row[key]?.toLowerCase()?.includes(search?.toLowerCase())
                )
            );
            setRows(filtered);
        } else if (search === "") {
            setRows(allRows);
        }
    };

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [searchTerm]);

    const handleClickOpenModelUpdate = async (row: any) => {
        setSelectedRow(row);

        // Set selected role/department
        setRole(row?.Role_in_the_Company);
        setDepartment(row?.Department);

        // Fetch meta data
        const meta = await getRbacMetaDetails();
        console.log(meta);
        const metaData = meta?.data?.[0] || {};

        const roleData = metaData?.Role_in_the_Company;
        const departmentData = metaData?.Department;
        console.log("nnnnnn", meta);
        setRoles(roleData);
        setDepartments(departmentData);

        setOpen(true);
    };

    const handleCloseModelUpdate = () => {
        setOpen(false);
    };

    const handleClickOpenModelAdd = async () => {
        setOpenAdd(true);

        try {
            const response = await getAddedUser();
            const data = response?.data || [];
            setManagerOptions(data);
        } catch (err) {
            console.error("Error fetching manager details:", err);
        }

        // Also fetch roles & departments
        const meta = await getRbacMetaDetails();
        const metaData = meta?.data?.[0] || {};
        setRoles(metaData?.Role_in_the_Company?.map((r) => r.roleName) || []);

        setDepartments(metaData?.Department?.map((d) => d.deptName) || []);
    };

    const handleCloseModelAdd = () => {
        setOpenAdd(false);
        setNewManagerId("");
        setNewManagerName("");
        setNewManagerEmail("");
        setNewRole("");
        setNewDepartment("");
    };

    const handleUpdateRbacUser = async () => {
        if (!selectedRow) return;

        if (!role || !department) {
            alert("Please select both role and department");
            return;
        }

        const payload = {
            userId: selectedRow?.User_ID,
            department: department,
            roleInTheCompany: role
        };
        console.log("yyyy", payload);
        try {
            setIsLoading(true);
            const result = await updateRbacUser(payload);

            if (result?.status) {
                showToast({
                    message: `${selectedRow?.Manager_Name} Updated`,
                    type: "success"
                });
                fetchRbacData();
                setOpen(false);
            } else {
                showToast({
                    message: result?.message,
                    type: "error"
                });
            }
        } catch (error) {
            console.log(error);
            showToast({
                message: error?.message,
                type: "error"
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleAddRbacUser = async () => {
        if (!newManagerName || !newManagerEmail || !newRole || !newDepartment) {
            alert("Please fill all fields");
            return;
        }

        const payload = {
            userId: newManagerId,
            managerName: newManagerName,
            managerEmail: newManagerEmail,
            roleInTheCompany: newRole,
            department: newDepartment
        };

        try {
            setIsLoading(true);
            const result = await addRbacUser(payload);

            if (result?.status) {
                showToast({
                    message: `${newManagerName} Added`,
                    type: "success"
                });
                console.log("User added successfully:", result);
                fetchRbacData();
                handleCloseModelAdd();
                setNewManagerId("");
                setNewManagerName("");
                setNewManagerEmail("");
                setNewRole("");
                setNewDepartment("");
            } else {
                showToast({
                    message: result?.message,
                    type: "error"
                });
                console.error("Failed to add user:", result);
            }
        } catch (error) {
            showToast({
                message: error?.message,
                type: "error"
            });
            console.error("Error adding user:", error);
        } finally {
            setIsLoading(false);
        }
        setOpenAdd(false);
    };

    const confirmDeleteUser = async () => {
        if (!rowToDelete) return;

        try {
            setIsLoading(true);
            const result = await deleteRbacUser(rowToDelete?.ID);

            if (result?.status) {
                showToast({
                    message: `${rowToDelete.Manager_Name} Deleted`,
                    type: "success"
                });
                setRows((prev) => prev.filter((r) => r.ID !== rowToDelete.ID));
            } else {
                showToast({
                    message: result?.message || "Failed to delete user",
                    type: "error"
                });
            }
        } catch (error) {
            showToast({
                message: error?.message || "Error deleting user",
                type: "error"
            });
        } finally {
            setIsLoading(false);
            setOpenDeleteDialog(false);
            setRowToDelete(null);
        }
    };

    const columns: GridColDef[] = [
        // {
        //   field: "User_ID",
        //   headerName: "user id",
        //   disableColumnMenu: true,
        //   flex: 1,
        //   renderCell: (params) => (params.value ? params.value : "-"),
        // },
        {
            field: "Manager_Name",
            headerName: "Manager Name",
            disableColumnMenu: true,
            width: 200,
            renderCell: (params) => (params.value ? params.value : "-")
        },
        {
            field: "Manager_Email",
            headerName: "Manager Email",
            disableColumnMenu: true,
            flex: 2,
            renderCell: (params) => (params.value ? params.value : "-")
        },

        {
            field: "Role_in_the_Company",
            headerName: "Role in the Company",
            disableColumnMenu: true,
            flex: 2,
            renderCell: (params) => (params.value ? params.value : "-")
        },
        {
            field: "Department",
            headerName: "Department",
            disableColumnMenu: true,
            flex: 2,
            renderCell: (params) => (params.value ? params.value : "-")
        },

        {
            field: "action",
            headerName: "Action",
            disableColumnMenu: true,
            width: 150,
            renderCell: (params) => {
                const isCurrentUser =
                    params?.row?.Manager_Name === loggedInName;
                return (
                    <>
                        <Tooltip
                            title={
                                isCurrentUser
                                    ? "Can not update urself"
                                    : "Update"
                            }
                        >
                            <Button size="small" disabled={isCurrentUser}>
                                <DriveFileRenameOutlineOutlinedIcon
                                    onClick={() =>
                                        handleClickOpenModelUpdate(params?.row)
                                    }
                                />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <Button
                                size="small"
                                disabled={isCurrentUser}
                                onClick={() => handleDeleteUser(params?.row)}
                                color="error"
                            >
                                <DeleteOutlineIcon />
                            </Button>
                        </Tooltip>
                    </>
                );
            }
        }
    ];

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "10px" }}>
                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>
                {[
                    <>
                        <Typography key="final" sx={{ fontSize: "14px" }}>
                            RBAC
                        </Typography>
                    </>
                ]}
            </Breadcrumbs>

            <Typography variant="h5" mb={1}>
                RBAC
            </Typography>
            <Box
                sx={{
                    borderRadius: "5px",
                    marginTop: "16px",
                    background: "#fff",
                    padding: "15px"
                }}
            >
                <Grid container spacing={2} mb={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Grid container spacing={2}>
                            {/* Search Section */}
                            {allRows?.length > 1 && (
                                <Grid size={{ xs: 12, md: 7 }}>
                                    <TextField
                                        label="Search by Manager Name & Manager Email"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                        inputRef={searchInputRef}
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Button
                            sx={{ float: "right" }}
                            variant="outlined"
                            color="primary"
                            onClick={handleClickOpenModelAdd}
                        >
                            Add User
                        </Button>
                    </Grid>
                </Grid>
                <Paper
                    sx={{
                        // height: 400,
                        height:
                            rows?.length > 4
                                ? "62vh"
                                : rows?.length > 0
                                  ? "auto"
                                  : "62vh",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    {!isLoading ? (
                        rows?.length > 0 ? (
                            <DataGridPro
                                rows={rows}
                                columns={columns}
                                getRowId={(row) => row?.id}
                                pagination={rows?.length > 10}
                                pinnedColumns={pinnedColumns}
                                onPinnedColumnsChange={
                                    handlePinnedColumnsChange
                                }
                                paginationModel={paginationModel}
                                onPaginationModelChange={setPaginationModel}
                                pageSizeOptions={[10, 20]}
                                disableRowSelectionOnClick={true}
                                // initialState={{
                                //   sorting: {
                                //     sortModel: [{ field: "Manager_Name", sort: "asc" }],
                                //   },
                                // }}
                            />
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "8px",
                                    padding: "20px"
                                }}
                            >
                                {searchTerm && rows?.length === 0 ? (
                                    "No Options available"
                                ) : (
                                    <>
                                        <img
                                            src={emptyImage}
                                            alt="Empty"
                                            width="300px"
                                        />
                                        <b style={{ color: "#0009" }}>
                                            No CORFQs Captured yet
                                        </b>
                                    </>
                                )}
                            </div>
                        )
                    ) : (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="50vh"
                        >
                            <ThreeDot
                                color="#1976d2"
                                size="medium"
                                text=""
                                textColor=""
                            />
                        </Box>
                    )}
                </Paper>
            </Box>

            {/* -----------------Update User----------------- */}

            <Dialog
                onClose={handleCloseModelUpdate}
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth={fullWidth}
                maxWidth={maxWidth}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Update User
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseModelUpdate}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500]
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <TextField
                        required
                        fullWidth
                        label="Manager Name"
                        value={selectedRow?.Manager_Name}
                        disabled
                        sx={{ marginBottom: "20px" }}
                    />

                    <TextField
                        required
                        fullWidth
                        label="Manager Email"
                        value={selectedRow?.Manager_Email}
                        disabled
                        sx={{ marginBottom: "20px" }}
                    />

                    <Autocomplete
                        options={Array.isArray(roles) ? roles : []}
                        value={role || null}
                        onChange={(event, newValue) => setRole(newValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Role in the company"
                                sx={{ marginBottom: "15px" }}
                            />
                        )}
                    />
                    <Autocomplete
                        options={Array.isArray(departments) ? departments : []}
                        value={department || null}
                        onChange={(event, newValue) => setDepartment(newValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Department"
                                sx={{ marginBottom: "15px" }}
                            />
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        autoFocus
                        onClick={handleUpdateRbacUser}
                        disabled={isLoading}
                    >
                        {isLoading ? "Updating Please Wait" : "Update"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* -----------------Add User----------------- */}
            <Dialog
                onClose={handleCloseModelAdd}
                aria-labelledby="customized-dialog-title1"
                open={openAdd}
                fullWidth={fullWidth}
                maxWidth={maxWidth}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title1">
                    Add User
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseModelAdd}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500]
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Autocomplete
                        fullWidth
                        options={
                            Array.isArray(managerOptions) ? managerOptions : []
                        }
                        getOptionLabel={(option) => {
                            if (!option) return "";
                            if (typeof option === "string") return option;
                            return option?.Name || "";
                        }}
                        noOptionsText="No managers found"
                        value={
                            newManagerName
                                ? managerOptions?.find(
                                      (opt) => opt?.Name === newManagerName
                                  ) || null
                                : null
                        }
                        onChange={(event, newValue) => {
                            setNewManagerName(newValue?.Name || "");
                            setNewManagerEmail(newValue?.Email || "");
                            setNewManagerId(newValue?.ID || "");
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Manager Name"
                                sx={{ marginBottom: "20px" }}
                            />
                        )}
                    />

                    <TextField
                        required
                        fullWidth
                        disabled
                        label="Manager Email"
                        value={newManagerEmail}
                        onChange={(e) => setNewManagerEmail(e.target.value)}
                        sx={{ marginBottom: "20px" }}
                    />

                    <Autocomplete
                        fullWidth
                        options={Array.isArray(roles) ? roles : []}
                        value={newRole || null}
                        onChange={(event, newValue) =>
                            setNewRole(newValue || "")
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Role in the company"
                                sx={{ marginBottom: "15px" }}
                            />
                        )}
                    />

                    <Autocomplete
                        fullWidth
                        options={Array.isArray(departments) ? departments : []}
                        value={newDepartment || null}
                        onChange={(event, newValue) =>
                            setNewDepartment(newValue || "")
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Department"
                                sx={{ marginBottom: "15px" }}
                            />
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        autoFocus
                        onClick={handleAddRbacUser}
                        disabled={isLoading}
                    >
                        {isLoading ? "Adding Please Wait" : "Add"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* -----------------Delete User----------------- */}
            <Dialog
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
            >
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete{" "}
                    <strong>{rowToDelete?.Manager_Name}</strong>?
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setOpenDeleteDialog(false)}
                        color="primary"
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={confirmDeleteUser}
                        color="error"
                        disabled={isLoading}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
